import { envia_mail_desbloqueio } from 'backend/email.jsw';
import { formataCNPJ, formataCelularBr, somenteNumeros } from 'public/scriptGeral.js';
import wixWindow from 'wix-window'; //Permite abrir o lightbox (janela de envio)



$w.onReady(function () {



});

export function btnContraSenha_click(event) {
	//envia o e-mail
	envia_mail_desbloqueio($w('#inputNome').value, $w('#inputRazaoSocial').value, $w('#inputCNPJ').value, $w('#inputCelular').value, $w('#inputRep').value.padStart(17,"0"), '#'+$w('#inputSenha').value.padStart(10,"0"), $w('#inputEmail').value, $w('#checkAceita').value)

	//Limpa os campos
	$w('#inputNome').value = ''
	$w('#inputRazaoSocial').value = ''
	$w('#inputCNPJ').value = ''
	$w('#inputCelular').value = ''
	$w('#inputRep').value = ''
	$w('#inputSenha').value = ''
	$w('#inputEmail').value = ''

	//Abre o lightbox com a mensagem de envio
	wixWindow.openLightbox('SolicitacaoEnviadaREP');

}

export function inputCNPJ_keyPress(event) {

	$w('#inputCNPJ').value = formataCNPJ($w('#inputCNPJ').value);

}

export function inputCNPJ_input(event) {
	 
	$w('#inputCNPJ').value = formataCNPJ($w('#inputCNPJ').value);
}

export function inputCelular_keyPress(event) {
	$w('#inputCelular').value = formataCelularBr($w('#inputCelular').value);
}

export function inputCelular_input(event) {
	$w('#inputCelular').value = formataCelularBr($w('#inputCelular').value);
}

export function inputRep_keyPress(event) {
	$w('#inputRep').value = somenteNumeros($w('#inputRep').value);
}

export function inputRep_input(event) {
	$w('#inputRep').value = somenteNumeros($w('#inputRep').value);
}

export function inputSenha_input(event) {
	$w('#inputSenha').value = somenteNumeros($w('#inputSenha').value);
}

export function inputSenha_keyPress(event) {
	$w('#inputSenha').value = somenteNumeros($w('#inputSenha').value);
}
